import { uploadOptionImages } from '../../common'
import { parseImage } from '../utils'
import { APIFoodUpselling } from '../foodUpselling/types/api/response-models'
import {
  productWithUpsellingParse,
  productWithUpsellingWrite,
} from '../productWithUpsellings'
import { APIUpselling } from '../upselling/types/api/response-models'
import {
  OptionedProductToApi,
  OptionGroupToAPI,
} from './types/api/request-models'
import { APIOptionedProduct, APIOptionGroup } from './types/api/response-models'
import {
  OptionedProduct,
  OptionGroup,
} from './types/internal/optionedProduct-models'

// ============
// PARSE
// ============

export const optionedProductParse = (
  res: APIOptionedProduct<APIUpselling | APIFoodUpselling>
): OptionedProduct => {
  return {
    ...res,
    ...productWithUpsellingParse(res),
    options: optionsParse(res.options),
  }
}

export const optionsParse = (apiOptions: APIOptionGroup[]): OptionGroup[] =>
  apiOptions.map((opt) => {
    return {
      ...opt,
      maxSelection: opt.maxSelection ?? null,
      items: opt.items.map((optItem) => ({
        ...optItem,
        isPriced: !!optItem.pricing.length,
        image: parseImage(optItem.image),
      })),
    }
  })

// ============
// WRITE
// ============

export const optionedProductWrite = async ({
  options,
  pricing,
  minQuantity,
  ...rest
}: OptionedProduct): Promise<OptionedProductToApi> => {
  const optionsImgUpl = uploadOptionImages(options ?? [])
  const optionsImg = await Promise.all([...optionsImgUpl])

  const opt = optionImageWrite(options ?? [], optionsImg)

  // here we remove isPriced flag from the object we send to api
  // and if pricing is not set for an option, we send an empty pricing
  const optionsToAPI = opt.map(
    (opt): OptionGroupToAPI => ({
      ...opt,
      maxSelection: opt.maxSelection ? opt.maxSelection : undefined,
      items: opt.items.map((optItem) => {
        const { isPriced, ...rest } = optItem
        return {
          ...rest,
          pricing: isPriced ? rest.pricing : [],
        }
      }),
    })
  )

  return {
    ...(await productWithUpsellingWrite(rest)),
    options: optionsToAPI,
    pricing,
    minQuantity,
  }
}

const optionImageWrite = (
  options: OptionGroup[],
  imagesArray: (string | undefined)[]
) =>
  options.map((option) => ({
    ...option,
    items: option.items.map((choice) => ({
      ...choice,
      image: imagesArray.shift(),
    })),
  }))
